// src/subscreens/Home/Home.js
import React, { useRef } from 'react';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import AboutSection from './AboutSection';
import CategoriesSection from './CategoriesSection';
import TeamSection from './TeamSection';
import ReviewsSection from './ReviewsSection';
//import Footer from '../../components/general/Footer';
import '../../../assets/css/home/Home.css';
const Home = () => {
  const featuresRef = useRef(null);

  const scrollToFeatures = () => {
    featuresRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="home-container">
      <HeroSection onExploreClick={scrollToFeatures} />
      <div ref={featuresRef}>
        <FeaturesSection />
      </div>
      <AboutSection />
      <CategoriesSection />
      <TeamSection />
      <ReviewsSection />

    </div>
  );
};

export default Home;